import React from "react";
import tools from "../../../helpers/tools";

// Cellule de date sur deux lignes : le jour en premier plan, l'heure en
// second (masquée avec `withTime={false}`).
const DateCell = ({ value, withTime = true, empty = "—" }) =>
  value ? (
    <>
      <span className="cell-primary">{tools.formatDate(value)}</span>
      {withTime && <span className="cell-secondary">{tools.formatDate(value, "HH:mm")}</span>}
    </>
  ) : (
    <span className="text-muted">{empty}</span>
  );

export default DateCell;
